/**
 * Marker Manager - Handles all marker operations outside of React lifecycle
 */

const markerManager = {
  markers: {},
  processingUpdate: false,

  // Create a new marker or update an existing one
  createOrUpdateMarker(floorId, markerId, focalPointX, focalPointY, markerTitle) {
      // Prevent recursive updates
      if (this.processingUpdate) return false;
      this.processingUpdate = true;

      // Clean up any existing markers for this marker ID
      this.removeMarker(markerId);

      // Try finding the floor image container
      const floorElement = document.querySelector(`.floor-item[data-floor-id="${floorId}"]`);

      // No floor element found
      if (!floorElement) {
          this.processingUpdate = false;
          return false;
      }

      // Find the image element within the floor container
      const imageElement = floorElement.querySelector('img');

      if (!imageElement) {
          this.processingUpdate = false;
          return false;
      }

      // Create a marker element
      const markerElement = document.createElement('div');
      const markerClassName = `marker-overlay marker-overlay-${markerId}`;
      markerElement.className = markerClassName;
      markerElement.setAttribute('data-marker-id', markerId);
      markerElement.setAttribute('title', markerTitle || '');

      // Style the marker
      markerElement.style.position = 'absolute';
      markerElement.style.zIndex = '100';
      markerElement.style.left = `${focalPointX}%`;
      markerElement.style.top = `${focalPointY}%`;
      markerElement.style.transform = 'translate(-50%, -50%)';
      markerElement.style.pointerEvents = 'none'; // Prevent stealing mouse events

      // Set the marker SVG
      markerElement.innerHTML = `
              <svg width="72" height="72" viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
                  <circle class="pulse-ring ring" cx="48" cy="48" r="24" />
                  <circle cx="48" cy="48" r="24" fill="#00667D" />
                  <rect x="47" y="36" width="2" height="24" fill="white" />
                  <rect x="60" y="47" width="2" height="24" transform="rotate(90 60 47)" fill="white" />
              </svg>
      `;

      // Find parent to attach marker to (the floor-image div)
      let parent = imageElement.closest('.floor-image');
      if (!parent) {
          // Fallback to the image's parent
          parent = imageElement.parentNode;
      }

      // Ensure the parent has relative positioning
      const computedStyle = window.getComputedStyle(parent);
      if (computedStyle.position === 'static') {
          parent.style.position = 'relative';
      }

      // Add the marker to the parent
      parent.appendChild(markerElement);

      // Store the marker reference
      this.markers[markerId] = {
          element: markerElement,
          floorId: floorId
      };

      this.processingUpdate = false;
      return true;
  },

  // Remove a marker by marker ID
  removeMarker(markerId) {
      // Check if we have a marker for this marker ID
      if (this.markers[markerId] && this.markers[markerId].element) {
          // Remove the element from the DOM if it's still attached
          if (this.markers[markerId].element.parentNode) {
              this.markers[markerId].element.remove();
          }
          // Delete the reference
          delete this.markers[markerId];
      }

      // Also remove any elements with this class that might be orphaned
      const className = `marker-overlay-${markerId}`;
      const orphanedMarkers = document.querySelectorAll(`.${className}`);
      orphanedMarkers.forEach(element => {
          element.remove();
      });
  },

  // Remove all markers
  removeAllMarkers() {
      // Remove all tracked markers
      Object.keys(this.markers).forEach(markerId => {
          this.removeMarker(markerId);
      });

      // Also remove any orphaned markers
      const allMarkers = document.querySelectorAll('.marker-overlay');
      allMarkers.forEach(element => {
          element.remove();
      });
  }
};

export default markerManager;
